import React, { useEffect, useState } from 'react'
import { Tooltip, Table, Input, Space, Button } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import { GET_ALL_PENDING_ADVISORY_FOR_ASSOCIATE } from './graphql/Queries'
import Page404 from 'components/Page404'
import PendingAdvisory from 'modules/PendingAdvisory'
import client from 'apollo'
import { GET_USER } from 'modules/Users/graphql/Queries'
import CustomMeta from 'components/CustomMeta'

const PendingAdvisoryForAssociate = () => {
  const [openAdvisory, setOpenAdvisory] = useState(false)
  const [clientData, setClientData] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const [data, setData] = useState([])
  const [allData, setAllData] = useState([])

  useEffect(() => {
    getAllPendingAdvisory()
  }, [])
  const getAllPendingAdvisory = () => {
    setLoading(true)
    setOpenAdvisory(false)
    client
      .query({
        query: GET_ALL_PENDING_ADVISORY_FOR_ASSOCIATE,
        variables: { isMenu: false },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        let advisoryData =
          res?.data?.getPendingAdvisoryForAssociate?.advisoryData?.map(
            (item, index) => {
              return { ...item, index: index + 1 }
            }
          )
        setAllData(advisoryData)
        setData(advisoryData)
        setOpenAdvisory(false)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        setOpenAdvisory(false)
        setError(err)
      })
      .finally(() => {
        setLoading(false)
        setOpenAdvisory(false)
      })
  }

  const getUserByClientCode = (id) => {
    client
      .query({
        query: GET_USER,
        variables: { id: id.toString() },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        setClientData(res?.data?.getUser)
        setOpenAdvisory(true)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const renderAction = (record) => {
    return (
      <div
        className='action-icons'
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <Tooltip title='View Advisory'>
          <EyeOutlined
            onClick={() => {
              getUserByClientCode(record?.userId)
            }}
          />
        </Tooltip>
      </div>
    )
  }
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    console.log(selectedKeys)
    const keyword = selectedKeys.toLowerCase()
    const filtered = allData.filter((item) =>
      item[dataIndex]?.toString().toLowerCase().includes(keyword)
    )
    setData(filtered)
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? e.target.value : '')
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type='primary'
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            size='small'
            style={{ width: 90 }}
            onClick={() => {
              clearFilters()
              setData(allData)
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
  })

  const columns = [
    { title: 'Sr. No', dataIndex: 'index', key: 'index', width: 100 },
    {
      title: 'Client Code',
      dataIndex: 'ClientCode',
      key: 'ClientCode',
      width: 150,
      ...getColumnSearchProps('ClientCode'),
    },
    {
      title: 'Client Name',
      dataIndex: 'Name',
      key: 'ClientName',
      ...getColumnSearchProps('Name'),
    },
    { title: 'Role Name', dataIndex: 'AssociteName', key: 'AssociteName' },
    { title: 'Role Type', dataIndex: 'role', key: 'role', width: 200 },
    {
      title: 'View Advisory',
      dataIndex: 'action',
      key: 'action',
      width: 150,
      render: (text, record) => renderAction(record),
    },
  ]

  if (error) return <Page404 />
  return (
    <>
      <CustomMeta title='Pending Advisory for Associate' />
      {!openAdvisory ? (
        <div className='main_display_div'>
          <div className='agreement_main_div'>
            <div className='agreement_text'>Pending Advisory</div>
          </div>
          <Table
            bordered
            loading={loading}
            dataSource={
              data
                ? data.map((item) => ({
                    ...item,
                    role:
                      item?.role === 'SALES_EXECUTIVE'
                        ? 'AIF_SALES_EXECUTIVE'
                        : item?.role?.replace(/_/g, ' '),
                  }))
                : []
            }
            columns={columns}
          />
        </div>
      ) : (
        <PendingAdvisory
          clientData={clientData}
          setOpenAdvisory={setOpenAdvisory}
          getAllPendingAdvisory={getAllPendingAdvisory}
        />
      )}
    </>
  )
}

export default PendingAdvisoryForAssociate
